import { render, staticRenderFns } from "./Cabinet.vue?vue&type=template&id=25a4ca7a&scoped=true"
import script from "./Cabinet.vue?vue&type=script&lang=js"
export * from "./Cabinet.vue?vue&type=script&lang=js"
import style0 from "./Cabinet.vue?vue&type=style&index=0&id=25a4ca7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4ca7a",
  null
  
)

export default component.exports